import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import {
  Menu,
  MenuItems,
  MenuPopover,
  MenuButton,
  MenuItem,
} from '@reach/menu-button'
import { positionRight } from '@reach/popover'

const propTypes = {
  actions: PropTypes.arrayOf(Types.menuAction).isRequired,
  buttonLabel: PropTypes.node,
  buttonAriaLabel: PropTypes.string.isRequired,
}

const defaultProps = {
  buttonLabel: <span aria-hidden="true">...</span>,
  // Call sites should pass a specific label (e.g. item + action type). This
  // fallback keeps the control programmatically named if a caller omits it.
  // WCAG 2.5.3: include the same visible characters (ellipsis) as the hidden label.
  buttonAriaLabel: 'Open actions menu ...',
}

function ActionMenu({ actions, buttonLabel, buttonAriaLabel, ...rest }) {
  return (
    <Menu>
      <MenuButton
        className="action-menu-button link-secondary"
        aria-label={buttonAriaLabel}
      >
        {buttonLabel}
      </MenuButton>
      <MenuPopover position={positionRight} {...rest}>
        <MenuItems>
          {actions.map(({ label, onSelect, icon: Icon, actionProps = {} }) => (
            <MenuItem key={label} onSelect={onSelect} {...actionProps}>
              {Icon && (
                <span className="action-menu-icon" aria-hidden>
                  <Icon />
                </span>
              )}
              {label}
            </MenuItem>
          ))}
        </MenuItems>
      </MenuPopover>
    </Menu>
  )
}

ActionMenu.propTypes = propTypes
ActionMenu.defaultProps = defaultProps

export default ActionMenu
